<template>
    <v-autocomplete
        v-model="model"
        :search-input.sync="search"
        :loading="loading"
        :items="items"
        outlined
        no-filter
        v-bind="$attrs"
    >
        <template
            v-for="(_, s) in $scopedSlots"
            #[s]="props"
        > 
            <slot
                :name="s"
                v-bind="props"
            /> 
        </template>
    </v-autocomplete>
</template>

<script>
import get from 'lodash/get'

export default {
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        filters: {
            type: Object,
            default: () => ({})
        },
        request: {
            type: [Function, String],
            required: true
        },
        initialValueRequest: {
            type: [Function, String],
            default: null
        },
        itemsMapKey: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            search: '',
            loading: false,
            items: [],
            debounce: null
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    methods: {
        async getResponse() {
            const payload = {
                search: this.search,
                filters: {
                    search: this.search,
                    ...this.filters,
                }
            }

            if (typeof this.request === 'function') {
                return this.request(payload)
            }

            const method = this.$api[this.request] 

            if (!method) {
                console.error('Method not found')

                return {
                    data: [],
                }
            }

            const response = await method(payload)

            if (response.error) {
                return {
                    error: true,
                    data: [],
                }
            }

            let data = response.message

            if (this.itemsMapKey) {
                data = get(response, this.itemsMapKey)
            }

            return {
                data,
            }
        },
        async getInitialValueResponse() {
            const payload = {
                id: this.value,
            }

            if (typeof this.initialValueRequest === 'function') {
                return this.initialValueRequest(payload)
            }

            const method = this.$api[this.initialValueRequest] 

            if (!method) {
                console.error('Initial value method not found')

                return null
            }

            const response = await method(payload)

            if (response.error) {
                return null
            }

            let data = response.message

            return data
        },
        async loadInitialValue() {
            if (!this.initialValueRequest || !this.value) {
                return
            }

            const item = await this.getInitialValueResponse() 

            if (!item) {
                this.loading = false
                return
            }

            this.items = [item, ...this.items]
        },
        async load(){
            this.loading = true 

            const { data } = await this.getResponse() 

            if (!Array.isArray(data)) {
                this.loading = false
                console.error('Data is not an array', data)
                return
            }

            this.items = data

            await this.loadInitialValue()

            setTimeout(() => {
                this.loading = false
            }, 1000)

        },
        debounceLoad(){
            clearTimeout(this.debounce)

            this.debounce = setTimeout(() => {
                this.load()
            }, 500)
        },
    },
    watch: {
        search: {
            immediate: true,
            handler: 'debounceLoad' 
        },
        filters: {
            deep: true,
            handler: 'debounceLoad'
        },
    }
}
</script>